document.addEventListener('DOMContentLoaded', () => {
  let tradeForm = document.getElementById('trade_form');
  let submitBtn = document.querySelector('#trade_form input[type=submit]');

  if (tradeForm) {
    tradeForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      let form = Object.fromEntries(new FormData(tradeForm));

      // // 2. Safely trigger reCAPTCHA Enterprise
      // if (typeof grecaptcha === 'undefined' || !grecaptcha.enterprise) {
      //   console.error('reCAPTCHA script not loaded.');
      //   handleFormError(form, 'reCAPTCHA script failed to load');
      //   return;
      // }

      try {
        // const token = await grecaptcha.enterprise.execute('6LezmnotAAAAACQ_JGPg1i2I-GGb477rqHFLpzNH');

        submitBtn.setAttribute('disabled', '');
        submitBtn.classList.remove('c-btn--hollow');
        document.querySelector('#trade-form__modal').style.display = 'flex';

        // // 2. Attach the token to the payload sent to Google Apps Script
        // form.recaptchaToken = token;

        let url = 'https://script.google.com/macros/s/AKfycbzYi_iPO2H8hJw3wyycmLNSS5_CO6xvRG-4e6inl2-kX4U5YRW02GNrzFRIy0Eh1wNo/exec';
        let params = {
          method: 'POST',
          // Changed Content-Type to text/plain to avoid CORS preflight issues with Google Apps Script
          headers: {
            'Content-Type': 'text/plain;charset=utf-8'
          },
          body: JSON.stringify(form)
        };

        const response = await fetch(url, params);
        const data = await response.json();

        // 3. Handle response based on Apps Script validation
        if (data.success) {
          tradeForm.reset();
          submitBtn.removeAttribute('disabled');
          submitBtn.classList.add('c-btn--hollow');
          window.location.href = '/pages/trade-program-thank-you';
        } else {
          // Throw error if reCAPTCHA verification failed on backend
          throw new Error(data.error || 'reCAPTCHA verification failed');
        }

      } catch (error) {
        // Failure / Spam handler
        let mailUrl = 'https://script.google.com/macros/s/AKfycbxtGs09MgImWMu1EHz_HQIXT9jmzeV478SEKhSxHGe5OywN3g0KP2mXYeDCJvnApRtE/exec';
        let mailPayload = {
          to: 'ishand@kulgrilles.com',
          subject: `New Trade Request from ${form?.emailAddress || 'unknown'} Failed`,
          body: `Please update support team to email ${form?.emailAddress || 'unknown'}. Trade failed due to: ${error.message || error}.`
        };
        
        fetch(mailUrl, { 
          method: "POST", 
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(mailPayload) 
        });

        submitBtn.removeAttribute('disabled');
        submitBtn.classList.add('c-btn--hollow');
        document.querySelector('#trade-form__modal').style.display = 'none';
        
        const el = document.getElementById('trade-error');
        if (el) {
          el.style.display = 'inline-block';
          const elementRect = el.getBoundingClientRect();
          const absoluteElementTop = elementRect.top + window.scrollY;
          const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);

          window.scrollTo({
            top: middle,
            behavior: 'smooth'
          });
        }
      }

      // grecaptcha.enterprise.ready(async () => {
      //   try {
      //     const token = await grecaptcha.enterprise.execute('6LezmnotAAAAACQ_JGPg1i2I-GGb477rqHFLpzNH');

      //     submitBtn.setAttribute('disabled', '');
      //     submitBtn.classList.remove('c-btn--hollow');
      //     document.querySelector('#trade-form__modal').style.display = 'flex';

      //     // 2. Attach the token to the payload sent to Google Apps Script
      //     form.recaptchaToken = token;

      //     let url = 'https://script.google.com/macros/s/AKfycbzYi_iPO2H8hJw3wyycmLNSS5_CO6xvRG-4e6inl2-kX4U5YRW02GNrzFRIy0Eh1wNo/exec';
      //     let params = {
      //       method: 'POST',
      //       // Changed Content-Type to text/plain to avoid CORS preflight issues with Google Apps Script
      //       headers: {
      //         'Content-Type': 'text/plain;charset=utf-8'
      //       },
      //       body: JSON.stringify(form)
      //     };

      //     const response = await fetch(url, params);
      //     const data = await response.json();

      //     // 3. Handle response based on Apps Script validation
      //     if (data.success) {
      //       tradeForm.reset();
      //       submitBtn.removeAttribute('disabled');
      //       submitBtn.classList.add('c-btn--hollow');
      //       window.location.href = '/pages/trade-program-thank-you';
      //     } else {
      //       // Throw error if reCAPTCHA verification failed on backend
      //       throw new Error(data.error || 'reCAPTCHA verification failed');
      //     }

      //   } catch (error) {
      //     // Failure / Spam handler
      //     let mailUrl = 'https://script.google.com/macros/s/AKfycbxtGs09MgImWMu1EHz_HQIXT9jmzeV478SEKhSxHGe5OywN3g0KP2mXYeDCJvnApRtE/exec';
      //     let mailPayload = {
      //       to: 'ishand@kulgrilles.com',
      //       subject: `New Trade Request from ${form?.emailAddress || 'unknown'} Failed`,
      //       body: `Please update support team to email ${form?.emailAddress || 'unknown'}. Trade failed due to: ${error.message || error}.`
      //     };
          
      //     fetch(mailUrl, { 
      //       method: "POST", 
      //       headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      //       body: JSON.stringify(mailPayload) 
      //     });

      //     submitBtn.removeAttribute('disabled');
      //     submitBtn.classList.add('c-btn--hollow');
      //     document.querySelector('#trade-form__modal').style.display = 'none';
          
      //     const el = document.getElementById('trade-error');
      //     if (el) {
      //       el.style.display = 'inline-block';
      //       const elementRect = el.getBoundingClientRect();
      //       const absoluteElementTop = elementRect.top + window.scrollY;
      //       const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);

      //       window.scrollTo({
      //         top: middle,
      //         behavior: 'smooth'
      //       });
      //     }
      //   }
      // });
    });
  }
});

let placeSearch;
let autocomplete;
const componentForm = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "long_name",
  postal_code: "short_name",
};

function initAutocomplete() {
  // Create the autocomplete object, restricting the search predictions to
  // geographical location types.        var defaultBounds = new google.maps.LatLngBounds(

  
  let tradeForm = document.getElementById('trade_form');

  var options = {
    types: ["geocode"],
		componentRestrictions: { country: ["ca", "us"] },
		fields: ["address_components", "geometry", "icon", "name"]
  };

  if(tradeForm) {
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("trade_address"),
      options
    );
    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.

    autocomplete.setFields(["address_component"]);
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    autocomplete.addListener("place_changed", fillInAddress);
  }
}


function fillInAddress() {
  // Get the place details from the autocomplete object.
  const place = autocomplete.getPlace();
  
  // console.log(place);
  //This is used to reset the form - ignore as separate fields are not added
  // for (const component in componentForm) {
  //   document.getElementById(component).value = "";
  //   document.getElementById(component).disabled = false;
  // }
  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  let val;
  for (const component of place.address_components) {
    let addressType = component.types[0];
    if (addressType === 'postal_code') {
      val = component[componentForm['postal_code']];
    }
  }

  document.getElementById('trade_address').value += `${val ? ` ${val}` : ''}`;
};